// extracted by mini-css-extract-plugin
export default {"block":"styles_block__CNfoc","body":"styles_body__PH4gg","title":"styles_title__SVdkp"};